import { AppConstants, ApplicationType } from '@shared/core';
import { environment } from '../../../environments/environment';
import { COFUS_DUNAV_TRANSLATION_MAP } from './cofus-dunav-translation.keys';
import { COFUS_GLOBOS_TRANSLATION_MAP } from './cofus-globos-translation.keys';

export const appConstants: AppConstants = {
    environment: environment,
    environmentConfigUrl: 'assets/environment-config/environment-config.json',
    joinDuplicatedSlotsAndTakeFirst: true,
    selfBookingTimeslotCombinationsThreshold: 160,
    maxConcurrentRequests: 40,
    numOfFreeSlotsPerRequest: 1000,
    defaultFreeSlotsToDateAddition: 3,
    noAuthHeader: 'NoAuth',
    externalUrls: {
        medifit: 'https://www.medifit.si/',
    },
    defaultDateFormat: 'YYYY-MM-DD',
    matomo: {
        siteId: 32,
        trackerUrl: 'https://data.medifit.si/',
    },
    styleLoader: {
        styleSheetId: 'mainStylesheet',
    },
    authJwtInterceptor: {
        accessTokenIgnoreUrl: '/token/',
        refreshTokenIgnoreUrl: '/refresh/',
    },
    applicationTypeCookieName: 'mca-application',
    languageCookieName: 'lang',
    redirectAfterLoginParameter: 'redirectAfterLogin',
    httpClient: {
        authBase: '/auth/v2',
        authBaseV1: '/booking',
        settingsBase: '/mca/settings',
        mcaBase: '/mca',
        legacyMedicalBase: '/medical',
        customersBase: '/mca/customers',
        bookingV2: '/booking/api/v2',
        patientApiBase: '/booking/patient/api',
    },
    appTypeTranslations: {
        [ApplicationType.COFUS_DUNAV]: COFUS_DUNAV_TRANSLATION_MAP,
        [ApplicationType.COFUS_GLOBOS]: COFUS_GLOBOS_TRANSLATION_MAP,
    },
};
